<template>
    <v-autocomplete
      v-if="items"
      :items="items"
      item-text="display_name"
      item-value="id"
      v-model="model"
      :label="label"
      :disabled="disabled"
    ></v-autocomplete>
  </template>
  
  <script>
import { mapActions } from 'vuex';

  export default {
    data() {
      return {
        model: this.value,
        items: null
      };
    },
    props: {
      value: {
        type: Number
      },
      label: {
        type: String
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      value() {
        this.model = this.value;
      },
      model() {
        this.$emit("input", this.model);
      }
    },
    mounted () {
        this.loadTaxes()
            .then(({taxes}) => {
                this.items = taxes
            })
    },
    methods: {
        ...mapActions('bexio', ['loadTaxes'])
    }
  };
  </script>
  
  <style>
  </style>